import { FC } from 'react'

import styled from 'styled-components'
import { useParams } from 'react-router-dom'

import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { ScheduleSteps } from 'src/Components/PrimaryScheduleTabs'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { ModalType } from 'src/Types/ui'
import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'
import { useGenresAndLanguagesAnalytics } from 'src/Hooks/useGenresAndLanguagesAnalytics'
import { useGetMetaAdsCampaignByIdQuery } from 'src/Redux/adsCampaignApi'
import { AdCampaignStrategyEnum } from 'src/Redux/ad-campaignApi'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`
const ContainerWithError = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`

const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const GenresList = styled(SubTitle)`
  font-weight: 400;
`

interface AdsScheduleGenresProps {
  genres: string[]
}

export const AdsScheduleGenres: FC<AdsScheduleGenresProps> = ({ genres }) => {
  const { setSearch } = useCustomSearchParams()
  const { handleGenrePopupOpenedEvent } = useGenresAndLanguagesAnalytics()
  const { number } = useParams()
  const { data } = useGetMetaAdsCampaignByIdQuery(Number(number))

  const buttonText =
    data?.strategy === AdCampaignStrategyEnum.PLAYLIST
      ? 'Add playlist genres'
      : 'Add genres'

  const titleText =
    data?.strategy === AdCampaignStrategyEnum.PLAYLIST
      ? 'Playlist genres'
      : 'Genres'

  const handleClick = (): void => {
    const query = {
      step: ScheduleSteps.SETTINGS,
      modal: ModalType.Genres,
    }
    setSearch(query)

    handleGenrePopupOpenedEvent({
      platformName: CampaignPlatformTypeEnum.META,
    })
  }

  if (!genres.length) {
    return (
      <AddParameterButton onClick={handleClick}>
        <span>{buttonText}</span>
      </AddParameterButton>
    )
  }
  const genresString = genres
    .map((genre) => capitalizeFirstLetter(genre || ''))
    .join(', ')

  return (
    <Container>
      <ContainerWithError>
        <Wrapper>
          <SubTitle>{titleText}</SubTitle>
          <GenresList translate='no'>{genresString}</GenresList>
        </Wrapper>
        <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
      </ContainerWithError>
    </Container>
  )
}
